// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e4was","col":"styles_col__3ksEo"};